// import React, { useEffect, useState } from 'react';
// import ReactImageZoom from 'react-image-zoom';
// import ReactStars from "react-rating-stars-component";
// import { useLocation, useNavigate } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';
// import { getAProduct, addTowishlist } from '../features/products/productSlice';
// import { getUserCart, addProdToCart, syncLocalCart } from '../features/user/userSlice';
// import { base_url } from '../utils/axiosConfig';
// import { Tab, Nav , Container, Row, Col} from 'react-bootstrap';
// import toast, { Toaster } from 'react-hot-toast';
// import axios from 'axios';
// import { FaArrowLeft, FaHeart } from "react-icons/fa";
// import { CiHeart } from "react-icons/ci";
// import { IoMdFlash, IoMdAdd } from "react-icons/io";
// import { MdDelete } from "react-icons/md";

// const SingleProduct = () => {
//   const [quantity, setQuantity] = useState(1);
//   const [mainImage, setMainImage] = useState('');
//   const [alreadyAdded, setAlreadyAdded] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [cartItem, setCartItem] = useState(null);
//   const [isWishlisted, setIsWishlisted] = useState(false);

//   const location = useLocation();
//   const navigate = useNavigate();
//   const getProductId = location.pathname.split("/")[2];
//   const dispatch = useDispatch();

//   const productState = useSelector(state => state.product.product);
//   const { isAuthenticated, cartProducts, user, wishlist } = useSelector(state => state.auth);

//   const role = user?.role || JSON.parse(localStorage.getItem('customer'))?.role;

//   useEffect(() => {
//     dispatch(getAProduct(getProductId));
//     if (isAuthenticated) {
//       dispatch(getUserCart());
//     }
//   }, [dispatch, getProductId, isAuthenticated]);

//   useEffect(() => {
//     if (productState?.images?.length > 0) {
//       setMainImage(`${base_url}${productState.images[0]?.url}`);
//     }
//   }, [productState]);

//   useEffect(() => {
//     if (!productState?._id) return;

//     let cart;
//     if (isAuthenticated) {
//       cart = cartProducts || [];
//     } else {
//       cart = JSON.parse(localStorage.getItem('cart')) || [];
//     }

//     const foundItem = cart.find(item => item?.ProductId?._id === productState._id);
//     setCartItem(foundItem || null);
//     setQuantity(foundItem?.quantity || 1);
//     setAlreadyAdded(!!foundItem);

//     if (Array.isArray(wishlist) && wishlist.length > 0) {
//       const added = wishlist.some(item => item._id === productState._id);
//       setIsWishlisted(added);
//     }
//   }, [cartProducts, isAuthenticated, productState, wishlist]);

//   // 🔹 Wishlist handler
//   const handleWishlist = async (e) => {
//     e.stopPropagation();

//     if (!isAuthenticated) {
//       toast('Please login to add to wishlist', { icon: '🔐' });
//       return;
//     }

//     if (role === "deliveryboy") {
//       toast.error("Delivery boys cannot add products to wishlist.");
//       return;
//     }

//     try {
//       await dispatch(addTowishlist(productState._id)).unwrap();
//       setIsWishlisted(!isWishlisted);
//       toast.success(isWishlisted ? 'Removed from wishlist!' : 'Added to wishlist!');
//     } catch (error) {
//       toast.error("Failed to update wishlist.");
//     }
//   };

//   const handleAddToCart = async () => {
//     if (role === "deliveryboy") {
//       toast.error("Delivery boys cannot add products to cart.");
//       return;
//     }

//     setLoading(true);
//     const finalPrice = productState?.offerPrice && productState.offerPrice > 0 ? productState.offerPrice : productState?.CurrentPrice;

//     if (!isAuthenticated) {
//       const localCart = JSON.parse(localStorage.getItem('cart')) || [];
//       const existingIndex = localCart.findIndex(item => item.ProductId._id === productState._id);
//       if (existingIndex !== -1) {
//         localCart[existingIndex].quantity += quantity;
//       } else {
//         localCart.push({
//           _id: `${productState._id}_${Date.now()}`,
//           ProductId: {
//             _id: productState._id,
//             title: productState.title,
//             images: productState.images
//           },
//           quantity,
//           price: finalPrice,
//           gst: productState.gst || 0
//         });
//       }
//       localStorage.setItem('cart', JSON.stringify(localCart));
//       dispatch(syncLocalCart(localCart));
//       toast.success('Added to cart!');
//       setAlreadyAdded(true);
//       setLoading(false);
//       return;
//     }

//     try {
//       const payload = {
//         ProductId: {
//           _id: productState._id,
//           title: productState.title,
//           images: productState.images,
//           price: finalPrice,
//         },
//         quantity: cartItem ? cartItem.quantity + quantity : quantity,
//         price: finalPrice,
//       };
//       await dispatch(addProdToCart(payload)).unwrap();
//       dispatch(getUserCart());
//       toast.success('Added to cart!');
//       setAlreadyAdded(true);
//     } catch (err) {
//       toast.error('Error adding to cart');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleBuyNow = async () => {
//     if (role === "deliveryboy") {
//       toast.error("Delivery boys cannot purchase products.");
//       return;
//     }

//     setLoading(true);
//     await handleAddToCart();
//     navigate("/cart");
//     setLoading(false);
//   };

//   const updateQuantityLocal = (newQty) => {
//     const localCart = JSON.parse(localStorage.getItem('cart')) || [];
//     const updated = localCart.map(item =>
//       item.ProductId._id === productState._id ? { ...item, quantity: newQty } : item
//     );
//     localStorage.setItem('cart', JSON.stringify(updated));
//     dispatch(syncLocalCart(updated));
//     setQuantity(newQty);
//   };

//   const updateQuantityAPI = async (newQty) => {
//     try {
//       const token = JSON.parse(localStorage.getItem('customer'))?.token;
//       const config = { headers: { Authorization: `Bearer ${token}` } };
//       await axios.put(`${base_url}user/updatecart`, {
//         ProductId: productState._id,
//         quantity: newQty,
//         price: productState.CurrentPrice
//       }, config);
//       dispatch(getUserCart());
//     } catch (err) {
//       toast.error('Failed to update quantity');
//     }
//   };

//   const increaseQuantity = () => {
//     if (role === "deliveryboy") {
//       toast.error("Delivery boys cannot update cart.");
//       return;
//     }
//     const newQty = quantity + 1;
//     setQuantity(newQty);
//     if (isAuthenticated) {
//       updateQuantityAPI(newQty);
//     } else {
//       updateQuantityLocal(newQty);
//     }
//   };

//   const decreaseQuantity = () => {
//     if (role === "deliveryboy") {
//       toast.error("Delivery boys cannot update cart.");
//       return;
//     }
//     const newQty = Math.max(1, quantity - 1);
//     setQuantity(newQty);
//     if (isAuthenticated) {
//       updateQuantityAPI(newQty);
//     } else {
//       updateQuantityLocal(newQty);
//     }
//   };

//   const handleRemove = async (cartItemId) => {
//     if (role === "deliveryboy") {
//       toast.error("Delivery boys cannot remove items from cart.");
//       return;
//     }

//     if (isAuthenticated) {
//       try {
//         const token = JSON.parse(localStorage.getItem('customer'))?.token;
//         const config = {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             Accept: 'application/json',
//             'Content-Type': 'application/json',
//           },
//         };
//         await axios.delete(`${base_url}user/delete-product-cart`, {
//           ...config,
//           data: { cartItemId },
//         });
//         toast.success('Item removed!');
//         dispatch(getUserCart());
//         setAlreadyAdded(false);
//       } catch (error) {
//         toast.error('Error removing item.');
//       }
//     } else {
//       const localCart = JSON.parse(localStorage.getItem('cart')) || [];
//       const updatedCart = localCart.filter(item => item._id !== cartItemId);
//       localStorage.setItem('cart', JSON.stringify(updatedCart));
//       dispatch(syncLocalCart(updatedCart));
//       toast.success('Item removed from local cart!');
//       setAlreadyAdded(false);
//     }
//   };

//   const getZoomProps = () => {
//     const screenWidth = window.innerWidth;
//     return {
//       width: screenWidth < 768 ? screenWidth - 40 : 400,
//       height: screenWidth < 768 ? 300 : 400,
//       zoomWidth: screenWidth < 992 ? 250 : 500,
//       img: mainImage,
//       zoomPosition: "right",
//     };
//   };

//   return (
//     <div className="container py-4">
//       <Toaster position="top-center" reverseOrder={false} />
//       <div className="d-flex align-items-center mb-3">
//         <span className="back-icon me-2" onClick={() => navigate(-1)} style={{ cursor: "pointer" }}>
//           <FaArrowLeft size={20} />
//         </span>
//         <h4 className="mb-0">Product Details</h4>
//       </div>

//       <div className="row gy-4">
//         {/* Left Column */}
//         <div className="col-md-6 d-flex">
//           <div className="border rounded p-2 w-100 position-relative">
//             {/* Wishlist Icon */}
//             <button
//               onClick={handleWishlist}
//               className="btn btn-sm position-absolute top-0 start-0 m-2 bg-white rounded-circle shadow-sm"
//               style={{ zIndex: 10 }}
//             >
//               {isWishlisted ? <FaHeart className="text-danger" /> : <CiHeart />}
//             </button>

//             {mainImage ? (
//               window.innerWidth < 768 ? (
//                 <img src={mainImage} className="img-fluid" alt="Product" />
//               ) : (
//                 <ReactImageZoom {...getZoomProps()} />
//               )
//             ) : (
//               <div className="text-center py-5">Loading image...</div>
//             )}

//             {/* Thumbnails */}
//             <div className="position-absolute top-0 end-0 me-2 mt-2 d-none d-md-flex flex-column gap-2" style={{ zIndex: 1 }}>
//               {productState?.images?.map((image, index) => (
//                 <img
//                   key={index}
//                   src={`${base_url}${image?.url}`}
//                   alt={`Thumb-${index}`}
//                   className="img-thumbnail"
//                   style={{ width: 70, height: 70, objectFit: 'cover', cursor: 'pointer' }}
//                   onClick={() => setMainImage(`${base_url}${image?.url}`)}
//                 />
//               ))}
//             </div>
//           </div>
//         </div>

//         {/* Right Column */}
//         <div className="col-md-6">
//           <h4 className="fw-bold">{productState?.title}</h4>
//           <div className="d-flex align-items-center gap-2 mb-2">
//             <ReactStars count={5} size={20} activeColor="#ffd700" />
//             <span className="text-muted small">(1200 Ratings)</span>
//           </div>
//           <h5 className="text-success mb-3">₹ {productState?.CurrentPrice}</h5>

//           <div className="mt-3 d-flex gap-2 align-items-center">
//             {alreadyAdded ? (
//               <>
//                 <div className="d-flex align-items-center border rounded">
//                   <button onClick={decreaseQuantity} className="btn btn-sm">−</button>
//                   <span className="px-2">{quantity}</span>
//                   <button onClick={increaseQuantity} className="btn btn-sm"><IoMdAdd /></button>
//                   <button onClick={() => handleRemove(cartItem?._id)} className="btn btn-sm text-danger">
//                     <MdDelete />
//                   </button>
//                 </div>
//                 <button onClick={() => navigate("/cart")} className="btn btn-success btn-sm">
//                   Go to Cart
//                 </button>
//               </>
//             ) : (
//               <>
//                 <button onClick={handleAddToCart} className="btn btn-primary btn-sm" disabled={loading}>
//                   {loading ? 'Adding...' : 'Add to Cart'}
//                 </button>
//                 <button
//                   onClick={handleBuyNow}
//                   className="btn btn-sm text-light"
//                   style={{ backgroundColor: "#fb641b", borderColor: "orange", fontWeight: '500' }}
//                   disabled={loading}
//                 >
//                   {loading ? (
//                     <>
//                       <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
//                       Processing...
//                     </>
//                   ) : (
//                     <>
//                       <IoMdFlash className="me-1" /> Buy
//                     </>
//                   )}
//                 </button>
//               </>
//             )}
//           </div>

//           <div className="mt-3">
//             <h6 className="fw-bold">Additional Information</h6>
//             <p>{productState?.remarks}</p>
//           </div>
//         </div>
//       </div>

//       <Container className="my-5">
//         <Tab.Container defaultActiveKey="description">
//           <Row>
//             <Col>
//               <Nav variant="pills" className="mb-4 flex-column flex-sm-row">
//                 <Nav.Item>
//                   <Nav.Link eventKey="description" className="px-4 py-2">Description</Nav.Link>
//                 </Nav.Item>
//                 <Nav.Item>
//                   <Nav.Link eventKey="specifications" className="px-4 py-2">Specifications</Nav.Link>
//                 </Nav.Item>
//               </Nav>
//             </Col>
//           </Row>
//           <Row>
//             <Col>
//               <Tab.Content className="p-4 bg-light rounded shadow-sm">
//                 <Tab.Pane eventKey="description" className="fade">
//                   <p className="text-muted mb-0">{productState?.description || 'No description available.'}</p>
//                 </Tab.Pane>
//                 <Tab.Pane eventKey="specifications" className="fade">
//                   {productState?.specifications ? (
//                     <ul className="list-group list-group-flush">
//                       {Object.entries(productState.specifications).map(([key, value], index) => (
//                         <li key={index} className="list-group-item d-flex justify-content-between align-items-center">
//                           <strong>{key}</strong>
//                           <span>{value}</span>
//                         </li>
//                       ))}
//                     </ul>
//                   ) : (
//                     <p className="text-muted mb-0">No specifications provided.</p>
//                   )}
//                 </Tab.Pane>
//               </Tab.Content>
//             </Col>
//           </Row>
//         </Tab.Container>
//       </Container>
//     </div>
//   );
// };

// export default SingleProduct;



import React, { useEffect, useState } from 'react';
import ReactImageZoom from 'react-image-zoom';
import ReactStars from "react-rating-stars-component";
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getAProduct, addTowishlist } from '../features/products/productSlice';
import { getUserCart, addProdToCart, syncLocalCart } from '../features/user/userSlice';
import { base_url } from '../utils/axiosConfig';
import { Tab, Nav , Container, Row, Col} from 'react-bootstrap';
import toast, { Toaster } from 'react-hot-toast';
import axios from 'axios';
import { FaArrowLeft, FaHeart } from "react-icons/fa";
import { CiHeart } from "react-icons/ci";
import { IoMdFlash, IoMdAdd } from "react-icons/io";
import { MdDelete } from "react-icons/md";
import RelatedProducts from '../components/RelatedProducts';

const SingleProduct = () => {
  const [quantity, setQuantity] = useState(1);
  const [mainImage, setMainImage] = useState('');
  const [alreadyAdded, setAlreadyAdded] = useState(false);
  const [loading, setLoading] = useState(false);
  const [cartItem, setCartItem] = useState(null);
  const [isWishlisted, setIsWishlisted] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  const getProductId = location.pathname.split("/")[2];
  const dispatch = useDispatch();

  const productState = useSelector(state => state.product.product);
  const { isAuthenticated, cartProducts, user, wishlist } = useSelector(state => state.auth);

  const role = user?.role || JSON.parse(localStorage.getItem('customer'))?.role;

  useEffect(() => {
    dispatch(getAProduct(getProductId));
    if (isAuthenticated) {
      dispatch(getUserCart());
    }
  }, [dispatch, getProductId, isAuthenticated]);

  useEffect(() => {
    if (productState?.images?.length > 0) {
      setMainImage(`${base_url}${productState.images[0]?.url}`);
    }
  }, [productState]);

  useEffect(() => {
    if (!productState?._id) return;

    let cart;
    if (isAuthenticated) {
      cart = cartProducts || [];
    } else {
      cart = JSON.parse(localStorage.getItem('cart')) || [];
    }

    const foundItem = cart.find(item => item?.ProductId?._id === productState._id);
    setCartItem(foundItem || null);
    setQuantity(foundItem?.quantity || 1);
    setAlreadyAdded(!!foundItem);

    if (Array.isArray(wishlist) && wishlist.length > 0) {
      const added = wishlist.some(item => item._id === productState._id);
      setIsWishlisted(added);
    }
  }, [cartProducts, isAuthenticated, productState, wishlist]);

  // 🔹 Wishlist handler
  const handleWishlist = async (e) => {
    e.stopPropagation();

    if (!isAuthenticated) {
      toast('Please login to add to wishlist', { icon: '🔐' });
      return;
    }

    if (role === "deliveryboy") {
      toast.error("Delivery boys cannot add products to wishlist.");
      return;
    }

    try {
      await dispatch(addTowishlist(productState._id)).unwrap();
      setIsWishlisted(!isWishlisted);
      toast.success(isWishlisted ? 'Removed from wishlist!' : 'Added to wishlist!');
    } catch (error) {
      toast.error("Failed to update wishlist.");
    }
  };

  const handleAddToCart = async () => {
    if (role === "deliveryboy") {
      toast.error("Delivery boys cannot add products to cart.");
      return;
    }

    setLoading(true);
    const finalPrice = productState?.offerPrice && productState.offerPrice > 0 ? productState.offerPrice : productState?.CurrentPrice;

    if (!isAuthenticated) {
      const localCart = JSON.parse(localStorage.getItem('cart')) || [];
      const existingIndex = localCart.findIndex(item => item.ProductId._id === productState._id);
      if (existingIndex !== -1) {
        localCart[existingIndex].quantity += quantity;
      } else {
        localCart.push({
          _id: `${productState._id}_${Date.now()}`,
          ProductId: {
            _id: productState._id,
            title: productState.title,
            images: productState.images
          },
          quantity,
          price: finalPrice,
          gst: productState.gst || 0
        });
      }
      localStorage.setItem('cart', JSON.stringify(localCart));
      dispatch(syncLocalCart(localCart));
      toast.success('Added to cart!');
      setAlreadyAdded(true);
      setLoading(false);
      return;
    }

    try {
      const payload = {
        ProductId: {
          _id: productState._id,
          title: productState.title,
          images: productState.images,
          price: finalPrice,
        },
        quantity: cartItem ? cartItem.quantity + quantity : quantity,
        price: finalPrice,
      };
      await dispatch(addProdToCart(payload)).unwrap();
      dispatch(getUserCart());
      toast.success('Added to cart!');
      setAlreadyAdded(true);
    } catch (err) {
      toast.error('Error adding to cart');
    } finally {
      setLoading(false);
    }
  };

  const handleBuyNow = async () => {
    if (role === "deliveryboy") {
      toast.error("Delivery boys cannot purchase products.");
      return;
    }

    setLoading(true);
    await handleAddToCart();
    navigate("/cart");
    setLoading(false);
  };

  const updateQuantityLocal = (newQty) => {
    const localCart = JSON.parse(localStorage.getItem('cart')) || [];
    const updated = localCart.map(item =>
      item.ProductId._id === productState._id ? { ...item, quantity: newQty } : item
    );
    localStorage.setItem('cart', JSON.stringify(updated));
    dispatch(syncLocalCart(updated));
    setQuantity(newQty);
  };

  const updateQuantityAPI = async (newQty) => {
    try {
      const token = JSON.parse(localStorage.getItem('customer'))?.token;
      const config = { headers: { Authorization: `Bearer ${token}` } };
      await axios.put(`${base_url}user/updatecart`, {
        ProductId: productState._id,
        quantity: newQty,
        price: productState.CurrentPrice
      }, config);
      dispatch(getUserCart());
    } catch (err) {
      toast.error('Failed to update quantity');
    }
  };

  const increaseQuantity = () => {
    if (role === "deliveryboy") {
      toast.error("Delivery boys cannot update cart.");
      return;
    }
    const newQty = quantity + 1;
    setQuantity(newQty);
    if (isAuthenticated) {
      updateQuantityAPI(newQty);
    } else {
      updateQuantityLocal(newQty);
    }
  };

  const decreaseQuantity = () => {
    if (role === "deliveryboy") {
      toast.error("Delivery boys cannot update cart.");
      return;
    }
    const newQty = Math.max(1, quantity - 1);
    setQuantity(newQty);
    if (isAuthenticated) {
      updateQuantityAPI(newQty);
    } else {
      updateQuantityLocal(newQty);
    }
  };

  const handleRemove = async (cartItemId) => {
    if (role === "deliveryboy") {
      toast.error("Delivery boys cannot remove items from cart.");
      return;
    }

    if (isAuthenticated) {
      try {
        const token = JSON.parse(localStorage.getItem('customer'))?.token;
        const config = {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        };
        await axios.delete(`${base_url}user/delete-product-cart`, {
          ...config,
          data: { cartItemId },
        });
        toast.success('Item removed!');
        dispatch(getUserCart());
        setAlreadyAdded(false);
      } catch (error) {
        toast.error('Error removing item.');
      }
    } else {
      const localCart = JSON.parse(localStorage.getItem('cart')) || [];
      const updatedCart = localCart.filter(item => item._id !== cartItemId);
      localStorage.setItem('cart', JSON.stringify(updatedCart));
      dispatch(syncLocalCart(updatedCart));
      toast.success('Item removed from local cart!');
      setAlreadyAdded(false);
    }
  };

  const getZoomProps = () => {
    const screenWidth = window.innerWidth;
    return {
      width: screenWidth < 768 ? screenWidth - 40 : 400,
      height: screenWidth < 768 ? 300 : 400,
      zoomWidth: screenWidth < 992 ? 250 : 500,
      img: mainImage,
      zoomPosition: "right",
    };
  };

  return (

    <>
    <div className="container py-4">
      <Toaster position="top-center" reverseOrder={false} />
      <div className="d-flex align-items-center mb-3">
        <span className="back-icon me-2" onClick={() => navigate(-1)} style={{ cursor: "pointer" }}>
          <FaArrowLeft size={20} />
        </span>
        <h4 className="mb-0">Product Details</h4>
      </div>

      <div className="row gy-4">
        {/* Left Column */}
        <div className="col-md-6 d-flex">
          <div className="border rounded p-2 w-100 position-relative">
            {/* Wishlist Icon */}
            <button
              onClick={handleWishlist}
              className="btn btn-sm position-absolute top-0 start-0 m-2 bg-white rounded-circle shadow-sm"
              style={{ zIndex: 10 }}
            >
              {isWishlisted ? <FaHeart className="text-danger" /> : <CiHeart />}
            </button>

            {mainImage ? (
              window.innerWidth < 768 ? (
                <img src={mainImage} className="img-fluid" alt="Product" />
              ) : (
                <ReactImageZoom {...getZoomProps()} />
              )
            ) : (
              <div className="text-center py-5">Loading image...</div>
            )}

            {/* Thumbnails */}
            <div className="position-absolute top-0 end-0 me-2 mt-2 d-none d-md-flex flex-column gap-2" style={{ zIndex: 1 }}>
              {productState?.images?.map((image, index) => (
                <img
                  key={index}
                  src={`${base_url}${image?.url}`}
                  alt={`Thumb-${index}`}
                  className="img-thumbnail"
                  style={{ width: 70, height: 70, objectFit: 'cover', cursor: 'pointer' }}
                  onClick={() => setMainImage(`${base_url}${image?.url}`)}
                />
              ))}
            </div>
          </div>
        </div>

        {/* Right Column */}
        <div className="col-md-6">
          <h4 className="fw-bold">{productState?.title}</h4>
          <div className="d-flex align-items-center gap-2 mb-2">
            <ReactStars count={5} size={20} activeColor="#ffd700" />
            <span className="text-muted small">(1200 Ratings)</span>
          </div>
          <div className="mb-3">
  {productState?.offerPrice && productState.offerPrice > 0 ? (
    <>
      <h5 className="text-success d-inline-block me-2">₹ {productState.offerPrice}</h5>
      <span className="text-muted text-decoration-line-through">
        ₹ {productState?.CurrentPrice}
      </span>
    </>
  ) : (
    <h5 className="text-success">₹ {productState?.CurrentPrice}</h5>
  )}
</div>


          <div className="mt-3 d-flex gap-2 align-items-center">
            {alreadyAdded ? (
              <>
                <div className="d-flex align-items-center border rounded">
                  <button onClick={decreaseQuantity} className="btn btn-sm">−</button>
                  <span className="px-2">{quantity}</span>
                  <button onClick={increaseQuantity} className="btn btn-sm"><IoMdAdd /></button>
                  <button onClick={() => handleRemove(cartItem?._id)} className="btn btn-sm text-danger">
                    <MdDelete />
                  </button>
                </div>
                <button onClick={() => navigate("/cart")} className="btn btn-success btn-sm">
                  Go to Cart
                </button>
              </>
            ) : (
              <>
                <button onClick={handleAddToCart} className="btn btn-primary btn-sm" disabled={loading}>
                  {loading ? 'Adding...' : 'Add to Cart'}
                </button>
                <button
                  onClick={handleBuyNow}
                  className="btn btn-sm text-light"
                  style={{ backgroundColor: "#fb641b", borderColor: "orange", fontWeight: '500' }}
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                      Processing...
                    </>
                  ) : (
                    <>
                      <IoMdFlash className="me-1" /> Buy Now
                    </>
                  )}
                </button>
              </>
            )}
          </div>

          <div className="mt-3">
            <h6 className="fw-bold">Description</h6>
             <p className="text-muted mb-0">{productState?.description || 'No description available.'}</p>
          </div>

          <div className="mt-3">
            <h6 className="fw-bold">Additional Information</h6>
            <p>{productState?.remarks || 'No Additional Information available.'}</p>
          </div>
        </div>
      </div>
    </div>

    <RelatedProducts currentProduct={productState} />

    </>
  );
};

export default SingleProduct;
